import styled from 'styled-components';

export const TableEmptyStateStyled = styled.div`
  padding: 20px 0;
  text-align: center;
`;
